// === BES Add-to-Cart injector for product cards ===
// Appends a full-width "Add to cart" button to the OUTER card wrapper so it
// renders BELOW the title and price (not over the image). Also runs on
// collection pages by virtue of being loaded site-wide.
(function () {
  function findVariantId(card) {
    var input = card.querySelector('input[name="id"][value]');
    if (input) return input.value;
    var dpid = card.querySelector('[data-variant-id]');
    if (dpid) {
      var v = dpid.getAttribute('data-variant-id');
      if (v) return v;
    }
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var m = link.href.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }
    return null;
  }
  function findProductUrl(card) {
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.href : null;
  }
  function isAlreadyDone(card) {
    return !!card.querySelector(':scope > .bes-add-to-cart, :scope > .product-grid__card > .bes-add-to-cart');
  }
  function getMountTarget(card) {
    // Prefer the outer product-grid__card flex column so the button lands
    // BELOW the title/price block. Fall back to the custom-element itself.
    return card.querySelector('.product-grid__card') || card.querySelector('.product-card__content') || card;
  }
  function injectButton(card) {
    if (isAlreadyDone(card)) return;
    var mount = getMountTarget(card);
    var variantId = findVariantId(card);
    var url = findProductUrl(card);
    var btn;
    if (variantId) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bes-add-to-cart';
      btn.textContent = 'Add to cart';
      btn.dataset.variantId = variantId;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.dataset.state = 'adding';
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (cr) { return cr.json(); });
        }).then(function (cart) {
          btn.dataset.state = 'added';
          btn.textContent = 'Added ✓';
          // Horizon: cart-icon, cart-drawer + cart-items all listen for 'cart:update'.
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'bes-add-to-cart', data: { source: 'bes-add-to-cart', itemCount: cart.item_count } } }));
          setTimeout(function () { btn.dataset.state = ''; btn.textContent = 'Add to cart'; }, 1800);
        }).catch(function () {
          btn.dataset.state = '';
          btn.textContent = 'Try again';
          setTimeout(function () { btn.textContent = 'Add to cart'; }, 1800);
        });
      });
    } else if (url) {
      btn = document.createElement('a');
      btn.href = url;
      btn.className = 'bes-add-to-cart';
      btn.textContent = 'View options';
    }
    if (btn) mount.appendChild(btn);
  }
  function cleanStaleButtons() {
    // Remove buttons that the OLD injector put inside the gallery.
    var stale = document.querySelectorAll('.card-gallery .bes-add-to-cart, [class*="card-gallery"] .bes-add-to-cart');
    stale.forEach(function (b) { b.remove(); });
  }
  function injectAll() {
    cleanStaleButtons();
    var cards = document.querySelectorAll('product-card, .product-card');
    cards.forEach(injectButton);
  }
  if (document.readyState !== 'loading') injectAll();
  else document.addEventListener('DOMContentLoaded', injectAll);
  setTimeout(injectAll, 600);
  setTimeout(injectAll, 1500);
  var observer = new MutationObserver(function () { injectAll(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
